import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookiesDataService } from '@nibtravel/shared/data-access/cookies';

@Injectable()
export class UrlParamService {
  constructor(
    private cookieService: CookiesDataService,
    private router: Router
  ) {}

  setPartnerCookie(): void {
    const partnerCode = this.getUrlParameter('partnerCode');
    if (partnerCode) {
      this.cookieService.set('PartnerCode', partnerCode);
    }
  }

  getUrlParameter(name: string): string | undefined {
    const tree = this.router.parseUrl(window.location.search);
    return tree.queryParams[name];
  }
}
